import React from 'react';
import styles from './favorite-words/FavoriteWordsView.module.css';
import { BookIcon } from '../../components/Icons';

const FavoriteWordsView = ({ groups, bookMetadata, onOpenBookWords }) => {
  if (!groups.length) {
    return (
      <div className={styles.noHistory}>
        <div className={styles.noHistoryIcon}><BookIcon size={48} /></div>
        <h3>还没有收藏的单词</h3>
        <p>在阅读时点击单词即可查看释义并收藏</p>
      </div>
    );
  }

  return (
    <div className={styles.wordsSectionWrapper}>
      {groups.map((bookGroup) => {
        const bookMeta = bookMetadata[String(bookGroup.bookId)] || {};
        const bookTitle = bookMeta.title || bookGroup.bookTitle || '未命名书籍';

        return (
          <button
            key={bookGroup.key}
            type="button"
            className={styles.wordsCard}
            onClick={() => onOpenBookWords(bookGroup)}
            aria-label={`查看${bookTitle}的收藏单词`}
          >
            <div className={styles.wordsCardTitle}>{bookTitle}</div>
            <span className={styles.wordsCardCount}>单词 {bookGroup.itemCount}</span>
          </button>
        );
      })}
    </div>
  );
};

export default FavoriteWordsView;

